import React from 'react';

import DiscountCouponMobilePng from '../images/discountCouponMobile.png';
import DiscountCouponMobileWebp from '../images/discountCouponMobile.webp';
import DiscountCouponPng from '../images/discountCoupon.png';
import DiscountCouponWebp from '../images/discountCoupon.webp';

import MovingVehicleMobilePng from '../images/movingVehicleMobile.png';
import MovingVehicleMobileWebp from '../images/movingVehicleMobile.webp';
import MovingVehiclePng from '../images/movingVehicle.png';
import MovingVehicleWebp from '../images/movingVehicle.webp';

import MovingBoxMobilePng from '../images/movingBoxMobile.png';
import MovingBoxMobileWebp from '../images/movingBoxMobile.webp';
import MovingBoxPng from '../images/movingBox.png';
import MovingBoxWebp from '../images/movingBox.webp';

import { OrderedList } from '../../../../../common/display/orderedList/OrderedList';
import { ImageSource } from '../../../../../common/display/imageSource/ImageSource';
import { useIntl } from '@/i18n';

export const HowItWorksTab = () => {
  const { t } = useIntl();
  const Item = OrderedList.Item;

  return (
    <div className='margin-bottom-xxl'>
      <OrderedList>
        <Item
          image={
            <ImageSource
              imageMobile={DiscountCouponMobilePng}
              imageMobileWebp={DiscountCouponMobileWebp}
              image={DiscountCouponPng}
              imageWebp={DiscountCouponWebp}
              imageAlt={t({
                id: 'benefits.relocationBox.modal.howItWorks.image1',
                defaultMessage: 'Discount coupon',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.relocationBox.modal.howItWorks.description1',
            defaultMessage:
              'Rabattcode im Online-Shop von Turtlebox einlösen und Turtleboxen zum ausgewählten Termin abholen oder liefern lassen.',
          })}
        />
        <Item
          image={
            <ImageSource
              image={MovingVehiclePng}
              imageWebp={MovingVehicleWebp}
              imageMobile={MovingVehicleMobilePng}
              imageMobileWebp={MovingVehicleMobileWebp}
              imageAlt={t({
                id: 'benefits.relocationBox.modal.howItWorks.image2',
                defaultMessage: 'Moving truck',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.relocationBox.modal.howItWorks.description2',
            defaultMessage: 'Umweltfreundlich und sicher umziehen.',
          })}
        />
        <Item
          image={
            <ImageSource
              image={MovingBoxPng}
              imageWebp={MovingBoxWebp}
              imageMobile={MovingBoxMobilePng}
              imageMobileWebp={MovingBoxMobileWebp}
              imageAlt={t({
                id: 'benefits.relocationBox.modal.howItWorks.image3',
                defaultMessage: 'Dolly Cart',
              })}
              sizes='100px'
            />
          }
          text={t({
            id: 'benefits.relocationBox.modal.howItWorks.description3',
            defaultMessage: 'Boxen zurückgeben oder von der neuen Adresse abholen lassen.',
          })}
        />
      </OrderedList>
    </div>
  );
};
